<p-dialog
    [header]="l('::ChangeCurrentVendor')"
    [modal]="true"
    [(visible)]="isVisible"
    [style]="{ width: '50rem' }"
    [breakpoints]="{ '1199px': '75vw', '575px': '90vw' }">

    @for (vendor of vendorsItems; track vendor.id) {
        <div class="row mb-2">
            <div class="col">
                <p-fluid>
                    <p-button
                        [label]="vendor.name"
                        [icon]="vendor.id === currentVendor?.id ? 'fas fa-map-marker-alt' : ''"
                        (onClick)="updateVendor(vendor)"
                        [outlined]="vendor.id !== currentVendor?.id">
                    </p-button>
                </p-fluid>
            </div>
        </div>
    }
</p-dialog>